import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem('cookieConsent');
    let timer;
    if (!hasConsent) {
      // Small delay so it pops up smoothly after initial page load
      timer = setTimeout(() => setIsVisible(true), 1000);
    }
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-card border border-border p-4 sm:p-6 rounded-2xl shadow-2xl flex flex-col sm:flex-row items-center justify-between gap-4 pointer-events-auto animate-in slide-in-from-bottom-8 fade-in duration-700">
        <p className="text-sm text-muted-foreground flex-1 text-center sm:text-left">
          We use cookies to improve your experience and store your preferences. 
          By continuing to use this site, you agree to our <Link to="/cookie-policy" className="text-foreground underline font-medium hover:text-accent transition-colors">Cookie Policy</Link>.
        </p>
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <button 
            onClick={handleAccept}
            className="flex-1 sm:flex-none bg-accent text-accent-foreground px-6 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap hover:opacity-90 transition-opacity"
          >
            Got it!
          </button>
          <button 
            onClick={handleAccept}
            className="text-muted-foreground hover:text-foreground p-2.5 bg-secondary rounded-xl transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
